import get from 'lodash/get';
import {GVR_HOST} from '../../constants/app';
import {FEED_CREATED} from '../../constants';

export const formatGvrUrl = couple => {
  const {gvrPath} = couple;

  return gvrPath ? `${GVR_HOST}/${gvrPath}` : null;
};

export const formatWwsUrl = couple => {
  let wwsUrl = get(couple, 'wws.websiteUrl');

  // Prod wws domains need "www"; QA ones can't have it.
  if (wwsUrl) {
    wwsUrl = `https://${wwsUrl
      .replace('www.theknot', 'theknot')
      .replace(/^\/+/, '')
      .replace(/^https?:?\/\//, '')}`
      .replace('https://theknot', 'https://www.theknot')
      .replace('www.qa-beta', 'qa-beta');

    if (wwsUrl.includes('theknot.com')) {
      wwsUrl = `${wwsUrl}/registry`;
    }
  }

  return wwsUrl || null;
};

export const getHasCashRegistry = couple => {
  if (couple.cashRegistry === undefined) {
    return false;
  }
  if (couple.cashRegistry.isCashRegistryActive === undefined) {
    return !!get(couple, 'cashRegistry.registryUuid', false);
  }
  return couple.cashRegistry.isCashRegistryActive;
};

export const getHasEverHadCashRegistry = couple => {
  const {cashRegistry} = couple;
  if (cashRegistry === undefined || !cashRegistry.registryUuid) {
    return false;
  }

  return true;
};

export const sortByTypeTierAndName = (a, b) => {
  // Registries with a retailerId should be sorted above ones without one.
  if (a.registryType < b.registryType) {
    return -1;
  }

  if (a.registryType > b.registryType) {
    return 1;
  }

  // If neither has a retailerId/the synced affiliate type, we should sort alphabetically by name.
  const retailerNameA =
    a.registryType === FEED_CREATED &&
    a.retailer &&
    (a.retailer.retailerName || a.retailer.name);
  const storeNameA = retailerNameA || a.manualRegistryName;
  const retailerNameB =
    b.registryType === FEED_CREATED &&
    b.retailer &&
    (b.retailer.retailerName || b.retailer.name);
  const storeNameB = retailerNameB || b.manualRegistryName;

  if (!storeNameA || !storeNameB) return 1;

  return storeNameA.localeCompare(storeNameB);
};
